exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2f0I_tTmloWZCp{display:flex;flex-direction:row;justify-content:space-between;margin-top:8px}._2f0I_tTmloWZCp button{flex:1;overflow:hidden;margin-right:8px}._2f0I_tTmloWZCp button:last-child{margin-right:0}", ""]);

// exports
exports.locals = {
	"buttons": "_2f0I_tTmloWZCp"
};